<template>
  <div>
    <vue-plyr
      ref="player"
      class="player"
      :options="{
        autoplay: false,
        controls: [
          'play',
          'progress',
          'current-time',
          'mute',
          'volume',
          'fullscreen',
        ],
        debug: false,
        fullscreen: {
          fallback: true,
          iosNative: true,
        },
      }"
    >
      <video playsinline controls crossorigin :poster="$props.poster">
        <source
          v-for="(file, index) in visibleFiles"
          v-bind:key="index"
          :src="file.link"
          :size="file.height"
          :type="file.type"
        />
      </video>
    </vue-plyr>
  </div>
</template>

<script>
import merge from 'lodash/merge';

export default {
  name: 'Player',
  props: ['files', 'poster'],
  components: {},
  computed: {
    player() {
      return this.$refs.player.player;
    },
    visibleFiles() {
      return this.$props.files.filter(file => {
        return [540, 720, 1080, 1280].includes(file.height);
      });
    },
  },
  mounted() {
    this.$emit('player', this.player);
    this.player.on('playing', () => this.$emit('playing'));
    this.player.on('pause', () => this.$emit('pause'));
    this.player.on('ended', () => this.$emit('ended'));
    this.player.on('loadstart', () => this.$emit('loadstart'));
    this.player.on('loadeddata', () => this.$emit('loadeddata'));
  },
};
</script>

<style scoped>
.player {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Player.vue